import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { DataNotFound } from '../../../components/DataNotFound';
import Banners from '../../../components/elements/Banners';
import { postAsync } from '../../../components/helper/axiosHelper';

const CategoryList = () => {
  const [apidata, setApidata] = useState([]);
  const [datanotfound, setDatanotfound] = useState(false);
  const isActive = useSelector((state) => state.toggle.isActive);
  const { t } = useTranslation();

  useEffect(() => {
    localStorage.setItem('isHome', true);
    postAsync(`ServiceForYou/ServiceForYouPublicPortal`).then((resp) => {
      setApidata(resp?.data);
      if (resp?.statusCode == 204) {
        setDatanotfound(true);
      }
    });
  }, []);

  const legit = [
    {
      title: 'Silver',
      limit: '1 - 1000',
      image: '/assets/sliver.svg',
    },
    {
      title: 'Gold',
      limit: '1001 - 10000',
      image: '/assets/gold.svg',
    },
    {
      title: 'Diamond',
      limit: '10001',
      image: '/assets/diamond.svg',
    },
  ];

  return (
    <div className="">
      <Banners />

      <div className="bg-gray-100 min-h-screen py-10 flex items-center justify-center">
        <div className="w-full max-w-5xl bg-white shadow-lg rounded-lg overflow-hidden">
          <div className="bg-customgreen px-5 py-4">
            <h1 className="text-center text-white md:text-3xl xss:text-2xl font-semibold">{t('Donation Points And Categories')}</h1>
          </div>
          <div className="flex justify-center gap-4 flex-wrap w-full py-8">
            {legit.map((item, index) => {
              return (
                <div className="space-y-2     ">
                  <div className="flex items-center gap-1 bg-green-100 p-1 rounded-sm">
                    <img width={25} height={45} src={item?.image} />
                    <div></div>
                    <p className="uppercase font-black">{t(item.title)}</p>
                    <img
                      width={50}
                      height={45}
                      src={`/assets/arrow.png`}
                      className={` ${isActive ? 'transform rotate-180' : ''} `}
                    />
                    <p className="uppercase font-extrabold">{item.limit}</p>
                  </div>
                </div>
              );
            })}
          </div>

          <div className=" px-4">
            <div className="flex justify-center flex-wrap -mx-3">
              {/* explicitly adding item */}

              {apidata.map((data, index) => (
                <div key={index} className={`w-full md:w-1/2 lg:w-1/3 px-3 mb-6 `}>
                  <div
                    className={`p-4 rounded-lg text-center items-center shadow-lg transition-transform duration-300 hover:scale-105 ${data.category === 'Diamond' ? 'bg-blue-100' : data.category === 'Gold' ? 'bg-customorange' : 'bg-gray-300'}`}
                  >
                    <div className="flex justify-center text-center items-center mb-4">
                      <img
                        width={100}
                        height={45}
                        src={
                          data.category === 'Diamond'
                            ? '/assets/diamond.svg'
                            : data.category === 'Gold'
                              ? '/assets/gold.svg'
                              : '/assets/sliver.svg'
                        }
                        alt={`${data.category} icon`}
                      />
                    </div>
                    <h2 className="text-xl  font-semibold text-gray-800 mb-2">{data?.name}</h2>
                    <p className="text-center text-gray-700 mb-2">
                      {t('Points')}: {data?.points}
                    </p>
                  </div>
                </div>
              ))}
              {datanotfound && <DataNotFound />}
              {/* explicitly adding item */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default CategoryList;
